import store from '@store'
import ReportsModule from './vuex/Reports'
import ReportTypes from './subpages/report-types/route'
import NewReport from './subpages/new-report/route'
import EditReport from './subpages/edit-report/route'

export default {
  path: '/reports',
  component: () => import(/* webpackChunkName: "reports" */ './Reports'),
  props: true,
  meta: {
    requiresAuth: true
  },
  beforeEnter: async (to, from, next) => {
    store.registerModule('reports', ReportsModule)
    await store.dispatch('reports/getReportTypesAndSavedReports')
    next()
  },
  children: [ReportTypes, NewReport, EditReport]
}
